import { Component, OnInit } from '@angular/core';
import { ApiService } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../../services/loader.service';
import { Location } from '@angular/common';

@Component({
    selector: 'ez-identity',
    template: require('./identity.component.html'),
    styles: [require('./identity.component.less')]
})
export class IdentityComponent implements OnInit {
    public lastname: string = '';
    public firstname: string = '';
    public submitButtonDisabled: boolean = false;
    public errorMsg: string;
    public typeStatus: string;

    constructor(
        private apiService: ApiService,
        private translate: TranslateService,
        private loaderService: LoaderService,
        private location: Location
    ) {}

    public ngOnInit() {
        this.loaderService.show();
        this.apiService.getAccountInformations().subscribe(
            (data) => {
                this.lastname = data.detail.lastname;
                this.firstname = data.detail.firstname;
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }

    public save() {
        this.errorMsg = '';
        this.loaderService.show();
        this.submitButtonDisabled = true;

        this.apiService.saveAccount({
            lastname: this.lastname,
            firstname: this.firstname
        }).subscribe(
            (res) => {
                this.submitButtonDisabled = false;
                this.translate.get('common.save-successfull').subscribe((str) => {
                    this.errorMsg = str;
                });
                this.typeStatus = 'success';
            },
            error => {},
            () => {
                this.loaderService.hide();
            }
        );
    }

    public back() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/identity/identity.component.ts